
import { defineComponent, PropType, ref, onMounted } from 'vue';
import { MaterialTree, Roles } from '../../../types';
import SubjectCardHeader from './SubjectCardHeader.vue';
import TopicItem from '../topic/TopicItem.vue';
import Autentication from '../../../boot/services/Authentication';

export default defineComponent({
  name: 'SubjectCard',
  components: {
    SubjectCardHeader,
    TopicItem,
  },
  props: {
    tree: {
      type: Object as PropType<MaterialTree>,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const check = ref(false);
    const opened = ref(false);
    const loading = ref(false);
    const showContent = ref(false);
    const showPracticeBtn = ref(false);
    const expandCard = () => {
      opened.value = true;
    };

    onMounted(() => {
      showPracticeBtn.value = Autentication.hasRoleBySlug([
        Roles.FIRST_STEP_MODULE,
        Roles.OBJECTIVE_MODULE,
      ]);
    });

    return {
      showPracticeBtn,
      loading,
      opened,
      showContent,
      check,
      expandCard,
    };
  },
});
